<template>
  <div class="hb-user-profile-header">
    <div class="top">
      <div class="space"></div>
      <span class="require-flag" v-if="required == true">*</span>
      <div class="title">
        {{ title }}
        <span>
          <el-link :underline="false" type="primary" class="link" @click="link_url">{{link}}</el-link>
        </span>
      </div>
      <i v-if="qa && qa.length > 0" class="el-icon-question"></i>
    </div>
    <div v-if="desc && desc.length > 0" class="desc">{{ desc }}</div>
  </div>
</template>
<script>
export default {
  name: "UserProfileHeader",
  props: {
    link: {
      default: ''
    },
    title: {
      default: "",
    },
    qa: {
      default: null,
    },
    desc: {
      default: "",
    },
    required: {
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    link_url() {
      this.$emit('link_url', this.evaluate)
    }
  }
};
</script>

<style lang="scss" scoped>
.link{
  margin-top: 5px;
}
.hb-user-profile-header {
  margin-bottom: 10px;
  margin-top: 10px;
  .top {
    .space {
      width: 10px;
      height: 18px;
      background-color: #409eff;
      margin-right: 10px;
    }
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    .title {
      font-size: 20px;
      color: #333;
      font-weight: 550;
    }
  }
  .desc {
    margin-top: 10px;
    font-size: 12px;
    color: #909399;
  }
  .require-flag {
    font-size: 20px !important;
    font-weight: 550 !important;
    color: red !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/userprofile_header.vue